<template>

  <div>
    <Index />
  </div>
</template>

<script>

  import Index from "@/components/index";

  export default {
    name: 'App',
    components: {
      Index
    }
  };
</script>

<style>

  * {
    margin: 0;
    padding: 0;
  }

  body {
    overflow: hidden;
  }
</style>

<style lang="scss">

  .dialog-cover {
    background-color: rgba($color: black, $alpha: 0.8);
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 300;
  }

  .btn {
    cursor: pointer;
  }
</style>
